import { Component, EventEmitter, Input, Output } from "@angular/core";

/**
 * Generated class for the GridPagerComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: "grid-pager",
  templateUrl: "grid-pager.html",
})
export class GridPagerComponent {
  @Input() showPager: boolean;
  @Input() currentPage: number;
  @Input() totalPages: number;
  @Output() pageChanged = new EventEmitter<number>();
  @Input() isZeroIndexed?: boolean = false;

  constructor() {}

  firstPage() {
    const minPage = this.isZeroIndexed ? 0 : 1;
    if (this.currentPage !== minPage) {
      this.pageChanged.emit(0);
    }
  }

  prevPage() {
    const minPage = this.isZeroIndexed ? 0 : 1;
    if (this.currentPage > minPage) {
      this.currentPage--;
      this.pageChanged.emit(this.currentPage);
    }
  }

  setPage(page: number) {
    if (page >= 0 && page <= this.totalPages && page !== this.currentPage) {
      this.currentPage = page;
      this.pageChanged.emit(this.currentPage);
    }
  }

  nextPage() {
    if (this.currentPage < this.totalPages - 1) {
      this.currentPage++;
      this.pageChanged.emit(this.currentPage);
    }
  }

  lastPage() {
    if (this.currentPage !== this.totalPages - 1) {
      this.pageChanged.emit(this.totalPages - 1);
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/grid-pager/grid-pager.ts